module.exports = __webpack_public_path__ + "static/media/18.78e4c7d6.jpg";